<template>
    <div class="special-info">
        <div class="content_warp">
            <div class="warp_sm">
                <div class="warp_bg">
                    <div scroll-y="true" enhanced="true" show-scrollbar="false" class="content_details">
                        <div class="content_details_warp">
                            <div class="wx_info">
                                <div class="wx_name">{{objPositionInfo.nickname}}</div>
                                <div class="wx_lotien_ingfo">{{objPositionInfo.city_name}} - {{objPositionInfo.plot}}</div>
                            </div>
                            <div class="goods_name">
                                <div>{{goodsType(objPositionInfo.goods_type)}}</div>
                                <div class="look">{{objPositionInfo.check_count}}</div>
                            </div>
                            <div class="content_title">
                                 {{objPositionInfo.title}}
                            </div>
                            <div class="content_text">
                                <div v-html="objPositionInfo.content"></div>
                            </div>
                            <div class="case_img">
                                <div class="case_img_url" v-for="(imgItem,imgIndex) in objPositionInfo.images_url" :key="imgIndex">
                                    <img mode="widthFix" :src="imgItem.image_path" />
                                </div>
                            </div>
                            <div class="message_time">留言时间：{{leavingTime(objPositionInfo.message_time)}}</div>
                            <div class="goods_list" v-for="item in objPositionInfo.goods_list" :key="item.id" @click="goShopDetails(item)">
                                <!-- {{item.position}} -->
                                <div class="goods_lable">
                                <div>案例场景同款商品</div>
                                <div class="go_detail">
                                        <img mode="widthFix" src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/letter/detail_goods.png" />
                                </div>
                                </div>
                                <div class="goods_list_warp">
                                    <div class="goods_list_warp_img">
                                        <img mode="widthFix" :src="item.mobile_thumb" />
                                    </div>
                                    <div class="goods_list_warp_info">
                                        <div class="goods_info_name">{{item.cate_name}}</div>
                                        <div class="goods_info_type">{{item.goods_name}}</div>
                                        <div class="goods_list_warp_point">
                                            <div v-for="i in arrAttr(item.attr)">· {{i.attr_value}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="content_btn" >
                                <div @click="toNearby">查看附近门店</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="warp_bottom">
                    <div class="logo_img">
                        <img mode="widthFix" src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/letter/logo_sms.png" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {requestAesPost5} from '@/libsV2/requestAes.js'
export default {
  name:'',
  created(){
      this.getInfo(this.$route.query.id)
  },
  data(){
   return {
       objPositionInfo:{
           goods_type:'',
       }
   }
  },
  methods:{
         //点击跳转详情页
        goShopDetails(item) {
               this.$router.push({path: "/shopp/details", query: {id: item.id}} );
        },
        toNearby() {  // 附近门店
           this.$common.redirect('/case/map/v2/store',{
                topicId:this.$route.query.id
            })
        },
        arrAttr (value) {
            if (!value || !value.length) {
                return
            }
            let arr = value.filter(function (item) {
                return item.attr_mean < 4 && item.attr_mean != 0;
            })
            return arr
        },
        leavingTime (value) {
        if (!value) {
            return
        }
        value = value.replaceAll('-','.')
        return value
        },
        goodsType (value) {
            let arrType = value.split(",").join(" · ");
            return '· ' + arrType
        },
      getInfo(id){
        this.$store.commit("loadSwitch", true);
        requestAesPost5('topic/subjectaes/info',{id:id}).then(res=>{
               this.$store.commit("loadSwitch", false);
            if (res.data.error == 0) {
                let objPositionInfo = res.data.data.result;
                objPositionInfo.content = objPositionInfo.content.replace(/\left/gi, 'justify');
                this.objPositionInfo=objPositionInfo
                console.log( this.objPositionInfo)
            }
        })
      },
  }
}
</script>

<style scoped lang="scss">
@import "./specialinfo.scss"

</style>